<section>
  <div class="t-panel filter-container">
    <!--orderIdMmd-->
    <input-wrap [class.mobile]="isFilterSelected('orderId')">
      <input
        #orderIdMmdInput
        class="t-input t-input-icon-search"
        type="text"
        [(ngModel)]="orderIdMmd"
        placeholder="{{ 'translate.general.orderIdMmd' | translate }}"
        (keypress)="onKeyPress($event)"
      />
    </input-wrap>

    <!--patient-->
    <input-wrap
      *ngIf="displayPatientFields"
      [class.mobile]="isFilterSelected('patient')"
    >
      <input
        class="t-input t-input-icon-search"
        type="text"
        [(ngModel)]="patientName"
        placeholder="{{ 'translate.general.patient' | translate }}"
        (keypress)="onKeyPress($event)"
      />
    </input-wrap>

    <!--clinic-->
    <input-wrap
      #clinicWrap
      *ngIf="displayClinic"
      [loading]="(clinicList$ | async) && (clinicList$ | async).loading"
      [class.mobile]="isFilterSelected('clinic')"
    >
      <p-multiSelect
        #clinic
        [options]="clinicList$ | async"
        [(ngModel)]="selectedClinicList"
        optionLabel="label"
        [filter]="true"
        [resetFilterOnHide]="true"
        [autofocusFilter]="true"
        filterBy="label,value.id"
        [filterPlaceHolder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.clinic' | translate"
        [showToggleAll]="false"
        [maxSelectedLabels]="2"
        [selectedItemsLabel]="
          'translate.general.multiselectItemsSelected' | translate
        "
        (onChange)="onFieldValueChanged($event, true)"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
      ></p-multiSelect>
      <clear-multi
        *ngIf="selectedClinicList.length > 0"
        (click)="selectedClinicList = []; filterDoctors(); search()"
      ></clear-multi>
    </input-wrap>

    <!--doctor-->
    <input-wrap
      [loading]="displayDoctorList && displayDoctorList.loading"
      [class.mobile]="isFilterSelected('doctor')"
    >
      <p-multiSelect
        #doctor
        [options]="displayDoctorList"
        [(ngModel)]="selectedDoctorList"
        optionLabel="label"
        [autofocusFilter]="true"
        [resetFilterOnHide]="true"
        [filter]="true"
        filterBy="label,value.id"
        [filterPlaceHolder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.doctor' | translate"
        [showToggleAll]="false"
        [maxSelectedLabels]="2"
        [selectedItemsLabel]="
          'translate.general.multiselectItemsSelected' | translate
        "
        (onChange)="onFieldValueChanged($event, false, true)"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
      ></p-multiSelect>
      <clear-multi
        *ngIf="selectedDoctorList.length > 0"
        (click)="selectedDoctorList = []; search()"
      ></clear-multi>
    </input-wrap>

    <!--rx item-->
    <input-wrap
      #rxItemWrap
      *ngIf="displayRXitems"
      [loading]="(rxItemList$ | async) && (rxItemList$ | async).loading"
    >
      <p-multiSelect
        #rxItem
        [options]="rxItemList$ | async"
        [(ngModel)]="selectedRxItemList"
        optionLabel="label"
        [filter]="true"
        [resetFilterOnHide]="true"
        [autofocusFilter]="true"
        filterBy="label,value.id"
        [filterPlaceHolder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.rxItem' | translate"
        [showToggleAll]="false"
        [maxSelectedLabels]="2"
        [selectedItemsLabel]="
          'translate.general.multiselectItemsSelected' | translate
        "
        (onChange)="onFieldValueChanged($event)"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
      ></p-multiSelect>
      <clear-multi
        *ngIf="selectedRxItemList.length > 0"
        (click)="selectedRxItemList = []; search()"
      ></clear-multi>
    </input-wrap>

    <!--stage-->
    <input-wrap
      [loading]="(stageList$ | async) && (stageList$ | async).loading"
      [class.mobile]="isFilterSelected('stage')"
    >
      <p-select
        #hasSearchDropdown
        [options]="stageList$ | async"
        optionLabel="label"
        [(ngModel)]="selectedStage"
        [resetFilterOnHide]="true"
        [filterPlaceholder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.stage' | translate"
        [filter]="true"
        [filterBy]="'label,value.altFilter'"
        name="selectedStageList"
        (onChange)="onFieldValueChanged($event)"
      >
      </p-select>
      <clear-multi
        *ngIf="selectedStage"
        (click)="selectedStage = null; search()"
      ></clear-multi>
    </input-wrap>

    <!-- urgency
    <input-wrap
      *ngIf="displayUrgency"
      [loading]="(urgencyList$ | async) && (urgencyList$ | async).loading"
      [class.mobile]="isFilterSelected('urgency')"
    >
      <p-select
        #hasSearchDropdown
        [options]="urgencyList$ | async"
        optionLabel="label"
        [(ngModel)]="selectedUrgency"
        [filterPlaceholder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.urgency' | translate"
        [filter]="true"
        [resetFilterOnHide]="true"
        name="selectedUrgencyList"
        (onChange)="onFieldValueChanged($event)"
      >
      </p-select>
      <clear-multi
        *ngIf="selectedUrgency"
        (click)="selectedUrgency = null; search()"
      ></clear-multi>
    </input-wrap> -->

    <!--ord tik-->
    <input-wrap *ngIf="labUserSw" [class.mobile]="isFilterSelected('ordTik')">
      <input
        class="t-input t-input-icon-search"
        type="text"
        [(ngModel)]="ordTik"
        placeholder="{{ 'translate.general.ordTik' | translate }}"
        (keypress)="onKeyPress($event)"
      />
    </input-wrap>

    <!--ord scan num-->
    <input-wrap
      *ngIf="labUserSw"
      [class.mobile]="isFilterSelected('ordScanNum')"
    >
      <input
        class="t-input t-input-icon-search"
        type="text"
        [(ngModel)]="ordScanNum"
        placeholder="{{ 'translate.general.ordScanNum' | translate }}"
        (keypress)="onKeyPress($event)"
      />
    </input-wrap>

    <!--chat-->
    <input-wrap [class.mobile]="isFilterSelected('chat')">
      <p-select
        #hasSearchDropdown
        [options]="chatFilterOptions"
        optionLabel="label"
        [(ngModel)]="selectedChatFilter"
        [placeholder]="'translate.inbox.chatFilter' | translate"
        [resetFilterOnHide]="true"
        name="selectedChatFilter"
        (onChange)="onFieldValueChanged($event)"
      >
      </p-select>
      <clear-multi
        *ngIf="selectedChatFilter"
        (click)="selectedChatFilter = null; search()"
      ></clear-multi>
    </input-wrap>

    <!--task owners-->
    <input-wrap
      #taskOwnerWrap
      *ngIf="displayTaskOwners"
      [loading]="(taskOwnerList$ | async) && (taskOwnerList$ | async).loading"
    >
      <p-multiSelect
        #taskOwner
        [options]="taskOwnerList$ | async"
        [(ngModel)]="selectedTaskOwnerList"
        optionLabel="label"
        [filter]="true"
        [resetFilterOnHide]="true"
        [autofocusFilter]="true"
        filterBy="label,value.id"
        [filterPlaceHolder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.taskUser' | translate"
        [showToggleAll]="false"
        [maxSelectedLabels]="2"
        [selectedItemsLabel]="
          'translate.general.multiselectItemsSelected' | translate
        "
        (onChange)="onFieldValueChanged($event)"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
      ></p-multiSelect>
      <clear-multi
        *ngIf="selectedTaskOwnerList.length > 0"
        (click)="selectedTaskOwnerList = []; search()"
      ></clear-multi>
    </input-wrap>

    <!-- deliverers-->
    <input-wrap
      *ngIf="displayDeliverers"
      [loading]="(delivererList$ | async) && (delivererList$ | async).loading"
    >
      <p-select
        #hasSearchDropdown
        [options]="delivererList$ | async"
        optionLabel="label"
        [(ngModel)]="selectedDeliverer"
        [resetFilterOnHide]="true"
        [filterPlaceholder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.deliverer' | translate"
        [filter]="true"
        [filterBy]="'label,value.altFilter'"
        name="selectedDelivererList"
        (onChange)="onFieldValueChanged($event)"
      >
      </p-select>
      <clear-multi
        *ngIf="selectedDeliverer"
        (click)="selectedDeliverer = null; search()"
      ></clear-multi>
    </input-wrap>

    <!-- favorite-->
    <input-wrap
      [class.mobile]="isFilterSelected('favorites')"
      [singleLine]="true"
      [labelAfter]="true"
      [selected]="favoriteSw"
    >
      <i
        class="fa-star icon-filter-fav"
        [class.fas]="this.favoriteSw"
        [class.selected]="this.favoriteSw"
        [class.far]="!this.favoriteSw"
        (click)="favoriteSw = !favoriteSw; search()"
      ></i>
    </input-wrap>

    <!-- tasks-->
    <input-wrap
      *ngIf="displayTasks"
      [class.mobile]="isFilterSelected('tasks')"
      [singleLine]="true"
      [labelAfter]="true"
      [selected]="tasksSw"
    >
      <img
        class="icon-task"
        [src]="
          tasksSw ? 'assets/img/Flag.svg' : 'assets/img/Flag_Dark_Grey.svg'
        "
        (click)="tasksSw = !tasksSw; search()"
      />
    </input-wrap>

    <!-- inhouse-->
    <input-wrap
      *ngIf="displayInhouse"
      [class.mobile]="isFilterSelected('inhouse')"
      [singleLine]="true"
      [labelAfter]="true"
      [selected]="inhouseSw"
    >
      <img
        class="icon-task"
        [src]="
          inhouseSw ? 'assets/img/inhouse.svg' : 'assets/img/inhouse_grey.svg'
        "
        (click)="inhouseSw = !inhouseSw; search()"
      />
    </input-wrap>

    <!-- qc mode-->
    <input-wrap
      *ngIf="displayQCMode"
      [class.mobile]="isFilterSelected('qcMode')"
      [singleLine]="true"
      [labelAfter]="true"
    >
      <p-toggleSwitch [(ngModel)]="qcModeSw" (onChange)="search()">
        <ng-template #handle let-checked="checked">
          <span>QC</span>
        </ng-template>
      </p-toggleSwitch>
    </input-wrap>

    <!-- rx -->
    <input-wrap
      *ngIf="displayRX"
      [class.mobile]="isFilterSelected('rx')"
      label="{{ 'translate.general.downloadRxFilter' | translate }}"
      [singleLine]="true"
      [labelAfter]="true"
      [selected]="rxSw"
    >
      <i
        class="fas fa-file icon-rx"
        [class.c1]="rxSw"
        [class.c-grey-med]="!rxSw"
        (click)="rxSw = !rxSw; search()"
      ></i>
    </input-wrap>

    <!-- mobile - filter by-->
    <input-wrap class="mobile-filter-by mobile">
      <p-multiSelect
        #filterBy
        [options]="displayedFilterList"
        [(ngModel)]="selectedFilters"
        optionLabel="label"
        [filter]="false"
        [placeholder]="'translate.general.filterBy' | translate"
        [showToggleAll]="false"
        [displaySelectedLabel]="false"
        (onChange)="onFilterByChanged($event)"
      ></p-multiSelect>
    </input-wrap>

    <div class="btn-container">
      <button class="t-button t-button--flat" (click)="search()">
        {{ "translate.general.search" | translate }}
      </button>

      <button class="t-button-outline c-c1" (click)="clearSearch()">
        {{ "translate.general.clearFilter" | translate }}
      </button>
    </div>

    <div class="results-per-page t-footnote">
      {{ "translate.general.display" | translate }}
      <span class="c1 fw-bold" (click)="resultsPerPagePanel.toggle($event)"
        >{{ curResultsPerPage }} <i class="fas c1 fa-chevron-down"></i
      ></span>
      {{ "translate.general.resultsPerPage" | translate }}
    </div>
  </div>
</section>

<p-popover
  #resultsPerPagePanel
  [dismissable]="true"
  class="resultsPerPagePanel"
  appendTo="body"
>
  <div class="page-options-container">
    <div *ngFor="let n of resultsPerPage">
      <a
        (click)="selectResultsPerPage(n, resultsPerPagePanel)"
        [class.fw-bold]="curResultsPerPage == n"
        >{{ n }}</a
      >
    </div>
  </div>
</p-popover>
